<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="suppliers"
            :description="false"
            search
            @selected="viewData"
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.Supplier") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Supplier' })"
                  size="small"
                  >{{ $t("setup.label.CreateSupplier") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.SupplierCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.SupplierDescription") }}</vs-th>
              <vs-th>{{ $t("setup.label.SupplierAddress") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="supplier"
                v-for="(supplier, index) in data"
              >
                <vs-td :data="supplier.supplierCode">{{
                  supplier.supplierCode
                }}</vs-td>
                <vs-td :data="supplier.supplierDescription">{{
                  supplier.supplierDescription
                }}</vs-td>
                <vs-td :data="supplier.supplierAddress">{{
                  supplier.supplierAddress
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      class="text-warning icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editData(supplier.id)"
                    />
                    <feather-icon
                    icon="TrashIcon"
                    :title="$t('setup.label.Delete')"
                    svgClasses="w-5 h-5 text-danger stroke-current cursor"
                    @click.stop="
                      deleteSupplierPopup = true;
                      delId = supplier.id;
                    "
                    class="icon_row"
                  />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
      <div class="centerx">
        <vs-popup
          classContent="popup-example"
          :title="$t('setup.label.DeleteSupplier')"
          :active.sync="deleteSupplierPopup"
          class="popup-close small-popup"
        >
          <div class="center">
            <img src="@/assets/images/pages/delete.svg" />
            <div class="success-msg">
              {{ $t("system.label.areYouSureDelete") }}
            </div>
          </div>

          <div class="center">
            <span class="p-2">
              <vs-button type="border" @click="deleteSupplierPopup = false">{{
                $t("system.label.cancel")
              }}</vs-button></span
            >

            <span class="p-2">
              <vs-button @click="removeItem(delId)">{{
                $t("setup.label.Ok")
              }}</vs-button>
            </span>
          </div>
          <div style="height: 20px"></div>
        </vs-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex/dist/vuex.common.js";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deleteSupplierPopup: false,
      delId: 0,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapGetters({ suppliers: "supplier/getSupplierList" }),
  },
  methods: {
    async getSupplierList() {
      this.loading = true;
      try {
        await this.$store.dispatch("supplier/setSupplierList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async removeItem(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("supplier/deleteSupplierAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Supplier Successfully Deleted",
          type: "success",
        });
        this.deleteSupplierPopup = false;
      } catch (error) {
        this.$toasted.error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    editData(id) {
      this.$router.push({ name: "Edit Supplier", params: { id: id } });
    },
    viewData(item) {
      this.$router.push({ name: "View Supplier", params: { id: item.id } });
    },
  },
  created() {
    this.getSupplierList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
